export const COLLABORATIONS_DATA = [
  {
    area: "Progettazione Strutturale",
    collaborators: [
      { name: "Federico dall’Oglio", profession: "Ingegnere" },
      { name: "Marco Bernabeni", profession: "Ingegnere" },
    ],
    delay: 100,
  },
  {
    area: "Progettazione Impianti Termici (Termotecnico)",
    collaborators: [{ name: "Metello Bianchi", profession: "Ingegnere" }],
    delay: 300,
  },
  {
    area: "Progettazione Impianti Elettrici e Fotovoltaici",
    collaborators: [
      {
        name: "Studio ELTEC Enrico Salomoni",
        profession: "Perito Industriale",
      },
      {
        name: "Studio tecnico professionale Daniele Baldassari",
        profession: "Perito Industriale",
      },
    ],
    delay: 200,
  },
  {
    area: "Pratiche Catastali",
    collaborators: [{ name: "Fabrizio Battesini", profession: "Geometra" }],
    delay: 400,
  },
  {
    area: "Sicurezza in Cantiere",
    collaborators: [
      { name: "Luca Lanfranchi", profession: "Geometra" },
      { name: "Andrea Meloni", profession: "Geometra" },
    ],
    delay: 600,
  },
  {
    area: "Acustica",
    collaborators: [
      { name: "Matteo Compri", profession: "Perito Industriale" },
    ],
    delay: 500,
  },
  {
    area: "Studio di Geologia",
    collaborators: [{ name: "Rosario Spagnolo", profession: "Geologo" }],
    delay: 800,
  },
  {
    area: "Certificazioni Energetiche",
    collaborators: [{ name: "Alessandro Veroni", profession: "Agronomo" }],
    delay: 700,
  },
];
